const CALCULATION_MILLISECONDS_TO_WAIT = 5000;

export { CALCULATION_MILLISECONDS_TO_WAIT };
